// src/components/scan/ScanReportCTA.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';

interface ScanReportCTAProps {
  onClick: () => void;
  variant: 'ready' | 'almost_ready';
}

const ScanReportCTA: React.FC<ScanReportCTAProps> = ({
  onClick,
  variant,
}) => {
  const { t } = useTranslation();

  const textKey =
    variant === 'ready'
      ? 'scan.reportCTA.ready'
      : 'scan.reportCTA.almost';

  return (
    <div className="mt-6 mb-10 flex justify-center">
      <div
        className="bg-accent hover:bg-yellow-600 text-white px-8 py-5 rounded-2xl shadow-lg flex items-center gap-4 cursor-pointer animate-pulse opacity-90 transition-all transform hover:scale-105 font-semibold"
        onClick={onClick}
      >
        <FileText className="w-7 h-7 text-textLight" />
        <span className="text-base sm:text-lg">{t(textKey)}</span>
      </div>
    </div>
  );
};

export default ScanReportCTA;
